export const numPrettier = (num: number | string) => {
  let parts = num.toString().split(".");
  const numberPart = parts[0];
  const decimalPart = parts[1];
  const thousands = /\B(?=(\d{3})+(?!\d))/g;
  return (
    numberPart.replace(thousands, " ") + (decimalPart ? "." + decimalPart : "")
  );
};

export const getYearMonth = (months: number) => {
  let m = months % 12;
  let y = (months - m) / 12;

  if (y > 1 && m > 1) {
    return `${y} years and ${m} months`;
  } else if (y === 1 && m > 1) {
    return `${y} year and ${m} months`;
  } else if (y > 1 && m === 1) {
    return `${y} years and ${m} month`;
  } else if (y === 1 && m === 1) {
    return `${y} year and ${m} month`;
  } else if (y > 1 && m === 0) {
    return `${y} years`;
  } else if (y === 1 && m === 0) {
    return `${y} year`;
  } else if (y === 0 && m > 1) {
    return `${m} months`;
  } else if (y === 0 && m === 1) {
    return `${m} month`;
  }
};
